import { render } from "./UiLayer.vue?vue&type=template&id=2697fcb6"
import script from "./UiLayer.vue?vue&type=script&lang=js"
export * from "./UiLayer.vue?vue&type=script&lang=js"

import "./UiLayer.vue?vue&type=style&index=0&id=2697fcb6&lang=scss"

import exportComponent from "C:\\Users\\jekr\\Documents\\au-csmv-touchkit\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__